<template lang="html" src="./Profile.html">

</template>

<script>
import mixins from "../../../../../Mixins.js";
export default {
  mixins: [mixins],
  data: () => ({
    profiles: [],
    poolAccounts: [],
    poolAccountSelected: {},
    profileName: null,
    profileId: null,
    profileValue: null,
    popupProfile: false,
    active: true,
    titlePopup: "Novo perfil",
    idCompany: null,
    invalidFields: {
      profileName: false,
      profileValue: false,
    },
  }),
  watch: {
    profileName: function () {
      const vm = this;
      vm.invalidFields.profileName = false;
    },
    profileValue: function () {
      const vm = this;
      vm.invalidFields.profileValue = false;
    },
  },
  mounted: function () {
    const vm = this;
    vm.init();
  },

  methods: {
    init() {
      const vm = this;
      if (vm.testNullUndefinedEmpty(vm.$route.params.id) === false) {
        vm.idCompany = vm.$route.params.id;
        vm.fetchPoolAccounts();
      }

      vm.fetchProfiles();
    },
    fetchPoolAccounts() {
      const vm = this;
      vm.axios
        .get(
          vm.$store.state.filooServer +
            "pool-profile/pool-company/" +
            vm.idCompany,
          {
            headers: { Authorization: vm.$session.get("bearer") },
          }
        )
        .then(function (response) {
          vm.poolAccounts = response.data;
        });
    },
    fetchProfiles() {
      const vm = this;
      vm.axios
        .get(vm.$store.state.filooServer + "pool-profile", {
          headers: { Authorization: vm.$session.get("bearer") },
        })
        .then(function (response) {
          vm.profiles = response.data;
        });
    },
    editProfile(tr) {
      const vm = this;
      vm.poolAccountSelected = tr;
      vm.profileName = tr.profile.name;
      vm.profileId = tr.profile.id;
      vm.profileValue = parseFloat(tr.value).toFixed(2);
      vm.titlePopup = "Editar: " + vm.profileName;
      vm.invalidFields.profileName = false;
      vm.invalidFields.profileValue = false;
      vm.popupProfile = true;
    },
    validateFields() {
      const vm = this;
      if (vm.testNullUndefinedEmpty(vm.profileName)) {
        vm.invalidFields.profileName = true;
      }
      if (vm.testNullUndefinedEmpty(vm.profileValue)) {
        vm.invalidFields.profileValue = true;
      }
      if (vm.invalidFields.profileName === false) {
        if (vm.testNullUndefinedEmpty(vm.profileId)) {
          vm.saveProfile();
        } else {
          vm.saveEditedProfile();
        }
      } else {
        vm.$vs.notify({
          title: "Atenção!",
          text: "Campos obrigatórios não preenchidos ou inválidos",
          color: "warning",
          icon: "error",
          position: "top-right",
        });
      }
    },
    newProfile() {
      const vm = this;
      vm.titlePopup="Adicionar";
      vm.profileName = "";
      vm.profileValue = "";
      vm.profileId = null;
      vm.poolAccountSelected = {};
      vm.invalidFields.profileName = false;
      vm.invalidFields.profileValue = false;
      vm.popupProfile = true;
    },
    saveProfile() {
      const vm = this;
      let profile = {
        description: vm.profileName,
        active: vm.active,
      };
      vm.axios
        .post(vm.$store.state.filooServer + "pool-profile", profile, {
          headers: { Authorization: vm.$session.get("bearer") },
        })
        .then(function (response) {
          if (response.status === 200 || response.status === 201) {
            vm.savePoolCompany(response.data);
          }
        })
        .catch(function () {
          vm.popupProfile = false;
          vm.$swal({
            title: "Atenção!",
            text:
              "Não foi possível criar um novo perfil.Contacte o administrador do sistema.",
            icon: "error",
          });
        });
    },
    savePoolCompany(profile) {
      const vm = this;
      let company = {
        active: true,
        value: parseFloat(vm.profileValue.replace(",", ".")),
        companyId: vm.idCompany,
        profileId: profile.id,
      };
      vm.axios
        .post(vm.$store.state.filooServer + "pool-profile/company", company, {
          headers: { Authorization: vm.$session.get("bearer") },
        })
        .then(function (response) {
          if (response.status === 200 || response.status === 201) {
            vm.fetchPoolAccounts();
            vm.profileName = "";
            vm.profileValue = "";
            vm.profileId = null;
            vm.poolAccountSelected = {};
            vm.popupProfile = false;
            vm.$swal({
              title: "Cadastro foi realizado com sucesso!",
              icon: "success",
            });
          }
        })
        .catch(function () {
          vm.popupProfile = false;
          vm.$swal({
            title: "Atenção!",
            text:
              "Não foi possível realizar esta operação, contacte o administrador do sistema.",
            icon: "error",
          });
        });
    },
    changeStatus(status, tr) {
      const vm = this;
      vm.active = status;
      vm.changeProfileStatus(tr.profile.id, tr);
    },
    changeProfileStatus(idProfile, poolAccount) {
      const vm = this;
      vm.axios.defaults.headers.common["Authorization"] = vm.$session.get(
        "bearer"
      );
      vm.axios
        .get(
          vm.$store.state.filooServer +
            "pool-profile/change-status/" +
            idProfile,
          {
            headers: { Authorization: vm.$session.get("bearer") },
          }
        )
        .then(function (response) {
          if (response.status === 200 || response.status === 201) {
            vm.changePoolAccountStatus(poolAccount.id);
          }
        })
        .catch(function () {
          vm.$swal({
            title: "Atenção!",
            text:
              "Não foi possível realizar esta operação, contacte o administrador do sistema.",
            icon: "error",
          });
        });
    },
    changePoolAccountStatus(id) {
      const vm = this;
      vm.axios.defaults.headers.common["Authorization"] = vm.$session.get(
        "bearer"
      );
      vm.axios
        .get(
          vm.$store.state.filooServer +
            "pool-profile/company/change-status/" +
            id,
          {
            headers: { Authorization: vm.$session.get("bearer") },
          }
        )
        .then(function (response) {
          if (response.status === 200 || response.status === 201) {
            vm.fetchPoolAccounts();
            vm.$swal({
              title: "Status alterado com sucesso!",
              icon: "success",
            });
          }
        })
        .catch(function () {
          vm.$swal({
            title: "Atenção!",
            text:
              "Não foi possível realizar esta operação, contacte o administrador do sistema.",
            icon: "error",
          });
        });
    },
    saveEditedProfile() {
      const vm = this;
      let profile = {
        id: vm.profileId,
        description: vm.profileName,
        active: vm.active,
      };
      vm.axios
        .put(
          vm.$store.state.filooServer + "pool-profile/" + vm.profileId,
          profile,
          {
            headers: { Authorization: vm.$session.get("bearer") },
          }
        )
        .then(function (response) {
          if (response.status === 200 || response.status === 201) {
            vm.saveEditedPoolCompany(response.data);
          }
        })
        .catch(function () {
          vm.popupProfile = false;
          vm.$swal({
            title: "Atenção!",
            text:
              "Não foi possível realizar esta operação, contacte o administrador do sistema.",
            icon: "error",
          });
        });
    },
    saveEditedPoolCompany(profile) {
      const vm = this;
      let value = null;
      let valueString = vm.profileValue.toString();
      if (valueString.indexOf(",") > -1) {
        value = parseFloat(vm.profileValue.replace(",", "."));
      } else {
        value = parseFloat(vm.profileValue);
      }
      let company = {
        id: vm.poolAccountSelected.id,
        active: vm.active,
        value: value,
        companyId: vm.idCompany,
        profileId: profile.id,
      };
      vm.axios
        .put(
          vm.$store.state.filooServer +
            "pool-profile/company/" +
            vm.poolAccountSelected.id,
          company,
          {
            headers: { Authorization: vm.$session.get("bearer") },
          }
        )
        .then(function (response) {
          if (response.status === 200 || response.status === 201) {
            vm.fetchPoolAccounts();
            vm.profileName = "";
            vm.profileValue = "";
            vm.profileId = null;
            vm.poolAccountSelected = {};
            vm.popupProfile = false;
            vm.$swal({
              title: "Dados alterados com sucesso!",
              icon: "success",
            });
          }
        })
        .catch(function () {
          vm.popupProfile = false;
          vm.$swal({
            title: "Atenção!",
            text:
              "Não foi possível realizar esta operação, contacte o administrador do sistema.",
            icon: "error",
          });
        });
    },
  },
};
</script>

<style lang="scss" src="./Profile.scss">
</style>
